// extracted by mini-css-extract-plugin
export default {"container":"duplicate-vasuli_container__OPmwE","message":"duplicate-vasuli_message__OLFrp","footer":"duplicate-vasuli_footer__kGt9Y"};